<template>
  <div class="bg-white shadow overflow-hidden">
    <div v-if="$slots.header" class="py-1 sm:px-6 border-b border-gray-200">
      <slot name="header" />
    </div>
    <div class="px-4 py-3">
      <slot></slot>
    </div>
  </div>
</template>